import React from "react";
import { ReactComponent as EditGoalIcon } from "../../../utilities/images/study_dashboard/edit_goal_icon.svg";
import "./DailyGoalEditIcon.css";

const DailyGoalEditIcon = () => (
  <EditGoalIcon className="daily-goal-edit-icon" aria-hidden="true" focusable="false" />
);

export default DailyGoalEditIcon;
